/**
 * Tracks page views on route changes.
 * Place inside <BrowserRouter> to access useLocation.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/analytics';

export function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Strip query params and hash to avoid capturing sensitive data (e.g. betaKey)
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
}
